import { ChapterLabel, Container, FadeUp } from "./ui";

const PLACEHOLDERS = [
  { role: "DIRIGEANT · CLIENT CORPORATE" },
  { role: "CLIENT PRIVÉ · PARIS" },
  { role: "OFFICE MANAGER · ENTREPRISE" },
];

const Testimonials = () => (
  <section className="border-t border-line bg-ink py-28 md:py-36" data-testid="testimonials-section">
    <Container>
      <ChapterLabel num="09" label="Ils Nous Confient Leurs Demandes" />

      <div className="mt-14 grid gap-5 md:grid-cols-3">
        {PLACEHOLDERS.map((t, i) => (
          <FadeUp key={t.role} delay={i * 0.12}>
            <figure
              className="flex h-full flex-col justify-between border border-line-light bg-surface p-8 md:p-10"
              data-testid={`testimonial-${i + 1}`}
            >
              <blockquote className="font-serif text-[22px] font-medium italic leading-[1.5] text-neutral-500">
                « [ Témoignage client ] »
              </blockquote>
              <figcaption className="mt-10">
                <p className="font-display text-[11px] font-semibold tracking-[0.16em] text-ivory">
                  — NOM DU CLIENT
                </p>
                <p className="mt-2 font-sans text-[10px] font-normal tracking-[0.14em] text-muted">
                  {t.role}
                </p>
              </figcaption>
            </figure>
          </FadeUp>
        ))}
      </div>
    </Container>
  </section>
);

export default Testimonials;
